//State ตัวเก็บข้อมูล หรือ state ก็คือตัวแปรที่เอาไว้เก็บค่าต่างๆที่เราประกาศไว้ ซึ่ง Vuex จะเข้ามาช่วยจัดการเจ้าตัวแปรพวกนี้
export const state = {
    appName: 'จัดการข้อมูลเว็บไซต์',
    layout: 'defalut',
    uid: null,
    name: null,
    email: null,
    error: null,
    loading: false,
    success: false,
    regisId: null,
    agents: null,
    userData: null,
    affiliate: null,
  }





// WEBPACK FOOTER //
// ./src/store/state.js